import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import history from '../../../core/history'
import { setUserLogout } from '../../../actions/logout'
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

//Component
import AdminDashboard from '../../../components/siteadmin/AdminDashboard';
import Loader from '../../../components/Loader';
import { withQuery } from '../../../hoc/withGraphql';

// GraphQL
import UserDashboard from './UserDashboard.graphql';
import ListingDashboard from './ListingDashboard.graphql';
import ReservationDashboard from './ReservationDashboard.graphql';
import GetAdminUser from './GetAdminUser.graphql'

class Dashboard extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        getUserData: PropTypes.object,
        ListingDashboard: PropTypes.object,
    };

    componentDidMount() {
        const { getAdminUser, setUserLogout } = this.props
        if (getAdminUser.getAdminUser === null) {
            setUserLogout({ isAdmin: true })
        }
    }

    render() {
        const { getUserData, getListingData, getReservationData, getAdminUser } = this.props;

        if (getUserData.loading || getListingData.loading || getReservationData.loading) {
            return <Loader type={"text"} />;
        } else if (getAdminUser.getAdminUser === null) {
            return (
                <div>
                    <Loader type={"text"} />
                </div>
            )
        }


        return <AdminDashboard
            user={getUserData}
            listing={getListingData}
            reservation={getReservationData}
        />;

    }
}
const mapState = state => ({})

const mapDispatch = {
    setUserLogout
}

export default compose(
    injectIntl,
    withQuery(UserDashboard,
        {
            name: 'getUserData',
            options: {
                fetchPolicy: 'network-only',
                ssr: false
            }
        }
    ),
    withQuery(ListingDashboard,
        {
            name: 'getListingData',
            options: {
                fetchPolicy: 'network-only',
                ssr: false
            }
        }
    ),
    withQuery(ReservationDashboard,
        {
            name: 'getReservationData',
            options: {
                fetchPolicy: 'network-only',
                ssr: false
            }
        }
    ),
    withQuery(GetAdminUser,
        {
            name: 'getAdminUser',
            options: {
                fetchPolicy: 'network-only',
                ssr: false
            }
        }
    ),
    (connect(mapState, mapDispatch))
)(Dashboard);